import { ListingSummary as PolarisListingSummary } from "@recore-solutions/nstar-lib";
import { Address } from "./address";
import { ListingStatusCodes } from "./listing-status";
import { AdBuilderCampaign } from "./AdBuilderCampaign";

export interface ListingSummary extends PolarisListingSummary {
	// Local additions not yet in the library can go here...
	listingTeamSK?: number;
	listingStatusCD: ListingStatusCodes;
	timezoneID?: string;
	adbuilderCampaign?: AdBuilderCampaign;
	adbuilderLoaded?: boolean;
	showPreviewAd?: boolean;
	canNavigate?: boolean;
}

export interface LegacyListingSummary {
	address: Address;
	status: string;
	listingClass: string;
	canEdit: boolean;
	canSpecialEdit: boolean;
	canDelete: boolean;
	canEditMedia: boolean;
	canEditOpenHouse: boolean;
	mlNumberForeign?: any;
	mlsnumber?: number;
	listAgent1Name?: string;
	permissionList?: string[];
}

export function getListingSummaryPropertyTypeCD(
	listingSummary: Pick<ListingSummary, "propertyTypeCD">
): string {
	return listingSummary.propertyTypeCD.replace("RLIT", "");
}
